import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Separator } from 'app/design/primitives/text-divider';
import { useTranslation } from 'react-i18next';
import type { NotificationToggle } from './notification-toggle.types';
import { ToggleRows } from './toggle-rows';

export const OptionalNotificationSection = ({
  helpKey,
  isLargeUI,
  titleKey,
  toggles,
  visible,
}: {
  helpKey: string;
  isLargeUI: boolean;
  titleKey: string;
  toggles: NotificationToggle[];
  visible: boolean;
}) => {
  const { t } = useTranslation('notifications-setting');
  if (!visible) return null;

  return (
    <Column gap="spacing.general.x2">
      <Separator onlyWidth />
      <Text
        fontWeight="700"
        textAlign={isLargeUI ? 'left' : 'center'}
        variant={isLargeUI ? 'bodyBase' : 'bodyLarge'}
        marginTop="spacing.general.x3"
      >
        {t(titleKey)}
      </Text>
      <Text variant="bodyBase">{t(helpKey)}</Text>
      <ToggleRows {...{ toggles }} />
    </Column>
  );
};
